import { Col } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Header, Item } from './';

const Container = styled.div`
  position: relative;
  height: 90%;
  max-height: 1024px;
  aspect-ratio: 9 / 16;
  background-color: ${theme.GREY_20};
`;

const ItemsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
`;

const Navigator = styled.div`
  width: 50%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  ${(props) => (props.left ? 'left: 0;' : 'right: 0;')}
`;

/**
 * Controls the current story batch belonging to a single user
 */
let touchInterval;
let durationInterval;
const ItemGroup = ({ data, handleNext, handlePrev }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const [state, setState] = useState(null);
  const pausedRef = useRef(false);
  const count = useRef(0);
  const progress = useRef(0);
  const direction = useRef(null);

  /**
   * Set defaults on batch update
   */
  useEffect(() => {
    setState(data);
    setIndex(0);
    count.current = 0;
  }, [data]);

  useEffect(() => {
    clearInterval(durationInterval);
    progress.current = 0;

    durationInterval = setInterval(() => {
      const currentProgress = progress.current;
      if (pausedRef.current) {
        // console.log('paused', currentProgress)

        return;
      }
      const itemDuration = state?.recent[index]?.duration || 15000;
      // console.log('itemDuration', itemDuration)
      const newProgress = currentProgress >= itemDuration ? 0 : currentProgress + 20;

      progress.current = newProgress;

      if (currentProgress >= itemDuration) {
        clearInterval(durationInterval);
        onMouseUp({ data: state, fromInterval: true });
      }

      // console.log('runnig', currentProgress)
    }, 20);
  }, [state, index]);

  useEffect(() => {
    return () => {
      clearInterval(touchInterval);
      clearInterval(durationInterval);
    };
  }, []);

  /**
   * Starts interval to count how long the press event continued
   * Pauses the story during mouse down
   */
  function onMouseDown({ left }) {
    touchInterval = setInterval(() => (count.current = count.current + 100), 100);
    setPaused(() => true);
    pausedRef.current = true;
    direction.current = left ? 'left' : 'right';
  }

  /**
   * If mouse down durationis less then 1 second, go next/prev
   * If longer than 1 second, continue story
   */
  function onMouseUp({ data, fromInterval }) {
    clearInterval(touchInterval);
    const isLeft = direction.current === 'left';

    if (!data) return;

    if (count.current < 700 || fromInterval) {
      clearInterval(durationInterval);
      switch (true) {
        case isLeft && index === 0:
          handlePrev();
          break;
        case isLeft:
          setIndex(index - 1);
          break;
        case index + 1 === data.recent.length:
          handleNext();
          break;
        default:
          setIndex(index + 1);
      }
    }

    setPaused(() => false);
    pausedRef.current = false;
    direction.current = null;
    count.current = 0;
  }

  function handlePaused(val) {
    console.log(val ? 'paused' : 'running');
    setPaused(() => val);
  }

  if (!data) return null;

  return (
    <Container>
      <Col>
        <Col zIndex="2">
          <Header data={data.recent} user={data.owner} index={index} paused={paused} />

          <Navigator
            left
            onMouseDown={() => onMouseDown({ left: true })}
            onMouseUp={() => onMouseUp({ data: state })}
          />

          <Navigator
            index={index}
            onMouseDown={onMouseDown}
            onMouseUp={() => onMouseUp({ data: state })}
          />
        </Col>
      </Col>

      <ItemsContainer>
        {data.recent.map((item, i) => (
          <Item
            key={item._id}
            item={item}
            index={i}
            isCurrent={index === i}
            paused={paused}
            handlePaused={handlePaused}
          />
        ))}
      </ItemsContainer>
    </Container>
  );
};

export default ItemGroup;
